import * as React from 'react';

export const useMediaQuery = (
  query: string,
  options: {defaultValue?: boolean} = {},
): boolean => {
  const getMatches = () =>
    typeof window !== 'undefined'
      ? window.matchMedia(query).matches
      : options.defaultValue ?? false;

  const [matches, setMatches] = React.useState(getMatches);

  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const mediaQuery = window.matchMedia(query);
    const listener = (event: MediaQueryListEvent) =>
      setMatches(event.matches);
    setMatches(mediaQuery.matches);
    if (mediaQuery.addEventListener) {
      mediaQuery.addEventListener('change', listener);
      return () => mediaQuery.removeEventListener('change', listener);
    } else {
      mediaQuery.addListener(listener);
      return () => mediaQuery.removeListener(listener);
    }
  }, [query]);

  return matches;
};
